import React, { useState } from 'react';
import { setAdminKey } from '../api';

const styles = {
  wrap: {
    maxWidth: 360,
    margin: '80px auto',
    padding: 32,
    background: '#1a1a1a',
    borderRadius: 8,
  },
  title: { marginBottom: 16, fontSize: 20, fontWeight: 700 },
  input: {
    width: '100%',
    padding: '10px 12px',
    background: '#111',
    border: '1px solid #333',
    borderRadius: 4,
    color: '#f0f0f0',
    fontSize: 14,
    marginBottom: 12,
  },
  btn: {
    width: '100%',
    padding: '10px 0',
    background: '#f9b000',
    border: 'none',
    borderRadius: 4,
    color: '#111',
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 14,
  },
};

export default function AdminKeyGate({ onKey }) {
  const [val, setVal] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (!val.trim()) return;
    setAdminKey(val.trim());
    sessionStorage.setItem('f1tips_adminkey', val.trim());
    onKey(val.trim());
  };

  return (
    <div style={styles.wrap}>
      <p style={styles.title}>Admin Access</p>
      <form onSubmit={submit}>
        <input
          type="password"
          style={styles.input}
          placeholder="Enter admin key"
          value={val}
          onChange={e => setVal(e.target.value)}
          autoFocus
        />
        <button type="submit" style={styles.btn}>Enter</button>
      </form>
    </div>
  );
}
